import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import api from "../../axiosConfig";

export default function BxvatEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ cod: "", descriere: "", procent: 0, ordine: 0 });

  useEffect(() => {
    let alive = true;
    api.get(`/bxvat/${id}`)
      .then((res) => {
        if (!alive) return;
        const d = res.data || {};
        setForm((f) => ({ ...f, cod: d.cod ?? "", descriere: d.descriere ?? "", procent: d.procent ?? 0, ordine: d.ordine ?? 0 }));
        setLoading(false);
      })
      .catch((err) => {
        alert("Eroare la încărcare: " + (err.response?.data?.detail || err.message));
        setLoading(false);
      });
    return () => { alive = false; };
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setForm((f) => ({ ...f, [name]: checked }));
    } else if (type === "number") {
      setForm((f) => ({ ...f, [name]: value === "" ? "" : Number(value) }));
    } else {
      setForm((f) => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const payload = { ...form };
      
      payload.procent = Number(form.procent) || 0;
      payload.ordine = Number(form.ordine) || 0;
      await api.put(`/bxvat/${id}`, payload);
      navigate("/bxvat");
    } catch (err) {
      alert("Eroare la actualizare: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return null; // sau un spinner

  return (
    <Container className="mt-4">
      <Card className="p-3">
        <h3>Editare Bxvat #{"{"}{id}{"}"}</h3>
        <Form onSubmit={handleSubmit}>
          <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>cod</Form.Label>
                  <Form.Control
                    type="text"
                    name="cod"
                    value={form.cod ?? ""}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>descriere</Form.Label>
                  <Form.Control
                    type="text"
                    name="descriere"
                    value={form.descriere ?? ""}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>procent</Form.Label>
                  <Form.Control
                    type="number"
                    name="procent"
                    value={form.procent ?? 0}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>ordine</Form.Label>
                  <Form.Control
                    type="number"
                    name="ordine"
                    value={form.ordine ?? 0}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
          </Row>
          <div className="text-end">
            <Button type="submit" disabled={submitting}>Salvează</Button>
          </div>
        </Form>
      </Card>
    </Container>
  );
}
